import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haHelpVideoPipe'
})
export class HaHelpVideoPipePipe implements PipeTransform {

  transform(helpVideoData: any[], searchTermVideoHa: string): any[] {
    if (!helpVideoData || !searchTermVideoHa) { return helpVideoData; }
    return helpVideoData.filter(a =>
      a.title.toLowerCase().indexOf(searchTermVideoHa.toLowerCase()) !== -1
   

    );
  }

}
